import Component from "../classes/Component";
import $ from 'jquery';


export default class Menu extends Component {
  constructor() {
    super({});
    this.element = document.querySelector("[data-component-menu]");
    this.init();
  }

  init() {
    if (this.element) {
      this.listenToggleMobile()
      this.openSubMenu()
      this.stickyMenu()
      this.ChangeTextSearch()
      this.language()
      this.expandedMenu()
    }
  }

  listenToggleMobile() {
    $('.header__burger').click(function () {
      $('.header__burger').toggleClass('css-open');
      $('.header__main').toggleClass('css-open');
    });
  }

  openSubMenu() {
    $('.menu-item-has-children >.arrow').click(function () {
      $(this).parent().toggleClass('css-open');
      $(this).next().slideToggle();
    })
  }

  language() {
    if ($(window).width() > 1024) {
      $('.header__lang').hover(function () {
            $(this).find('button').attr('aria-expanded', true);
          },
          function () {
            $(this).find('button').attr('aria-expanded', false);
          });

      var i = 0;
      $('.header__lang button').keypress(function (e) {
        i++;
        if (e.which == 13) {
          if(i % 2 == 0) {
            $(this).attr('aria-expanded', false);
          }
          else {
            $(this).attr('aria-expanded', true);
          }
        }
      });
    } else {
      $('.header__lang button').click(function () {
        if ($(this).attr('aria-expanded') == 'true') {
          $(this).attr('aria-expanded', false);
        } else {
          $(this).attr('aria-expanded', true);
        }
      });
    }
  }

  expandedMenu() {
    $('.menu-item-has-children').attr('aria-expanded','false');
    if ($(window).width() > 1024) {
      $('.menu-item-has-children').hover(function () {
            $(this).attr('aria-expanded', true);
          },
          function () {
            $(this).attr('aria-expanded', false);
          });
    } else {
      $('.menu-item-has-children .arrow').click(function () {
        if ($(this).closest('.menu-item-has-children').attr('aria-expanded') == 'true') {
          $(this).closest('.menu-item-has-children').attr('aria-expanded', false);
        } else {
          $(this).closest('.menu-item-has-children').attr('aria-expanded', true);
        }
      });
    }
  }

  stickyMenu() {
    $(window).scroll(function(){
      const sticky = $('.header'),
        scroll = $(window).scrollTop();

      if (scroll > 0) sticky.addClass('sticky');
      else sticky.removeClass('sticky');
    });
  }
   ChangeTextSearch() {
    $(window).on('load',function() {
      setTimeout(function() {
        $('.header__form-search .input-search').attr('data-acsb-tooltip', 'Entrez un mot-clé pour commencez votre recherche');
      }, 1000);
    });
  }
}